module.exports = __webpack_public_path__ + "img/image3.d999bc0d.png";